module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cFPaGf/tc-custom/9781788855808.jpg?1737125329718",
      "alt": "This image is the cover for the book Eagle and the Bear"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eagle and the Bear\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For over three centuries, the inhabitants of North Britain faced the might of Rome, resulting in some of the most extraordinary archaeology of the ancient world. This richly illustrated new history of Roman Scotland explores the complex, often tumultuous and frequently brutal interaction between the world's first superpower and the peoples who lived north of Hadrian's Wall. With reference to the latest research and featuring all the key sites, it offers though-provoking re-assessments of many aspects of the story of the Romans in Scotland, from the loss of the IXth Legion and the reasons for building and maintaining Hadrian's Wall, to considering what spurred at least four Roman emperors to personally visit the edge of the empire.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John H. Reid\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John H. Reid has had a lifelong fascination with Roman Scotland. He co-directed the Burnswark Project in Dumfriesshire, the ground-breaking archaeological dig of the only known Roman siege in Britain and has been Chairman of the Trimontium Trust in Melrose for the last 25 years. He has appeared on BBC TV and radio, is a regular speaker at major archaeological conferences and has been published widely in the academic and popular press.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Birlinn Ltd\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0